import React, { useContext, useEffect, useState } from "react";
import ListadoPostulantes from "../../pages/recruitment/ListadoPostulantes";
import NuevoColaborador from "../../pages/recruitment/NuevoColaborador";
import "./ReclutamientoAdmin.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import Permiso from "../../router/Permiso";
import { Plus } from "lucide-react";
import { EstadoPostulanteService } from "../../services/EstadoPostulante";
import { AuthContext } from "../../context/AuthContext";

const ReclutamientoAdmin = () => {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') || 'postulantes';
  const [tab, setTab] = useState(initialTab);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [estados, setEstados] = useState([]);

  const handleRefresh = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  const handleOpenNewRecruitment = () => {
    navigate("/admin/reclutamiento/registrar");
  };

  const cargarEStados = async () => {
    try {
      const response = await EstadoPostulanteService.getEstadoPostulacion(token);
      setEstados(response);
    } catch (error) {
      console.error("Error al cargar perfiles:", error);
    }
  };

  useEffect(() => {
    cargarEStados();
  }, []);

  const renderTab = () => {
    switch (tab) {
      case "postulantes":
        return <ListadoPostulantes token={token} onRefresh={handleRefresh} estados={estados} />;
      case "nuevo":
        return (
          <NuevoColaborador token={token} refreshTrigger={refreshTrigger} estados={estados} />
        );
      default:
        return null;
    }
  };

  return (
    <div className="usuarios-admin-outer">
      <div className="usuarios-admin-header">
        <div className="usuarios-admin-header-row">
          <div>
            <div className="usuarios-admin-title">Reclutamiento</div>
            <div className="usuarios-admin-subtitle">
              Gestión profesional de reclutamiento
            </div>
          </div>
          <div className="usuarios-admin-actions">
            <Permiso permiso="recruitment_add">
              <button onClick={handleOpenNewRecruitment} className="btn-nuevo">
                <Plus size={18} style={{ marginRight: "6px" }} /> Nuevo Postulante
              </button>
            </Permiso>
          </div>
        </div>
        <div className="usuarios-admin-tabs">
          <Permiso permiso="recruitment_list">
            <button
              className={tab === "postulantes" ? "active" : ""}
              onClick={() => setTab("postulantes")}
            >
              Listado de Postulantes
            </button>
          </Permiso>
          <Permiso permiso="recruitment_list_appointment">
            <button
              className={tab === "nuevo" ? "active" : ""}
              onClick={() => setTab("nuevo")}
            >
              Postulantes Citados
            </button>
          </Permiso>
        </div>
      </div>
      <div className="reclutamiento-admin-content">
        <div className="reclutamiento-admin-tab-content">{renderTab()}</div>
      </div>
    </div>
  );
};

export default ReclutamientoAdmin;
